import React, { useEffect, useState } from 'react'
import { FaSearch } from 'react-icons/fa'

import { useDebounce } from '../../../hooks/useDebounce.ts'
import { useUserAssignmentCode } from '../../../hooks/useUserAssignmentCode.ts'
import { convertOrderStatus } from '../../../utils/formatter.ts'
import Card from '../../common/Card/Card.tsx'
import Input from '../../common/forms/Input/Input.tsx'
import SelectInputs, {
  MultiOption
} from '../../common/forms/selectInputs/SelectInputs.tsx'

const multiOptions: MultiOption[] = [
  {
    value: '1',
    text: convertOrderStatus('waiting_for_realization'),
    field: 'waiting_for_realization',
    selected: false
  },
  {
    value: '2',
    text: convertOrderStatus('change_requested'),
    field: 'change_requested',
    selected: false
  },
  {
    value: '3',
    text: convertOrderStatus('in_progress'),
    field: 'in_progress',
    selected: false
  },
  {
    value: '4',
    text: convertOrderStatus('done'),
    field: 'done',
    selected: false
  }
]

export const multiOptionsLongDiet: MultiOption[] = [
  {
    value: '1',
    text: '30 dni',
    field: '1',
    selected: false
  },
  {
    value: '2',
    text: '90 dni',
    field: '3',
    selected: false
  },
  {
    value: '3',
    text: '180 dni',
    field: '6',
    selected: false
  },
  {
    value: '4',
    text: '360 dni',
    field: '12',
    selected: false
  }
]

const getFieldByValue = (
  value: string,
  multiOptions: MultiOption[]
): string | undefined => {
  const option = multiOptions.find((opt) => opt.value === value)
  return option?.field
}

const FilterSection = ({
  setFilterParams
}: {
  setFilterParams: React.Dispatch<React.SetStateAction<string | undefined>>
}) => {
  const { options } = useUserAssignmentCode()
  const [search, setSearch] = useState<string>('')
  const [multiOptionsCode, setMultiOptionsCode] = useState<MultiOption[] | null>(null)
  const [selectedInputsCode, setSelectedInputsCode] = useState<string[] | null>([])
  const [selectedInputsValuesStatus, setSelectedInputsValuesStatus] = useState<string[]>([])

  const [selectedInputsValuesLongDiet, setSelectedInputsValuesLongDiet] =
    useState<string[]>(['1', '2', '3', '4'])

  const debounceSearch = useDebounce(search, 400)

  useEffect(() => {
    setMultiOptionsCode(options)
  }, [options])

  useEffect(() => {
    if (selectedInputsValuesLongDiet.length === 0)
      setSelectedInputsValuesLongDiet(['1', '2', '3', '4'])
  }, [selectedInputsValuesLongDiet])

  useEffect(() => {
    if (multiOptionsCode && selectedInputsCode !== null) {
      const searchParams = debounceSearch
        ? `search=${debounceSearch}`
        : undefined

      let params = ''
      selectedInputsValuesStatus.map((item, index) => {
        const field = getFieldByValue(item, multiOptions)
        params =
          params +
          `${index === 0 ? '&status__in=' : ''}${field}${index === selectedInputsValuesStatus.length - 1 ? '' : ','}`
      })

      selectedInputsValuesLongDiet.map((item, index) => {
        const field = getFieldByValue(item, multiOptionsLongDiet)
        params =
          params +
          `${index === 0 ? '&subscription_length__in=' : ''}${field}${index === selectedInputsValuesLongDiet.length - 1 ? '' : ','}`
      })

      selectedInputsCode.map((item, index) => {
        const field = getFieldByValue(item, multiOptionsCode as MultiOption[])
        params =
          params +
          `${index === 0 ? '&user_assignment_code=' : ''}${field}${index === selectedInputsCode.length - 1 ? '' : ','}`
      })

      params =
        params !== undefined
          ? params + (searchParams ? `&${searchParams}` : '')
          : searchParams
            ? `?${searchParams}`
            : ''

      setFilterParams(params)
    }
  }, [
    debounceSearch,
    selectedInputsValuesStatus,
    selectedInputsValuesLongDiet,
    selectedInputsCode,
    multiOptionsCode,
    selectedInputsCode
  ])

  return (
    <Card>
      <Card.Title>Filtrowanie</Card.Title>
      <Card.Body>
        <div className="grid lg:grid-cols-3 gap-4">
          <div>
            <Input
              id="phrase"
              name="phrase"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Fraza"
              icon={<FaSearch />}
            />
          </div>
          <div>
            <SelectInputs
              label={'Filtruj wg długości diety'}
              startWhenEmptyValue={'Wybierz długość diety'}
              multiOptions={multiOptionsLongDiet}
              defaultSelected={[]}
              selectedInputsValues={selectedInputsValuesLongDiet}
              setSelectedInputsValues={setSelectedInputsValuesLongDiet}
            />
          </div>
          <div>
            <SelectInputs
              label={'Filtruj wg statusu zamówienia'}
              multiOptions={multiOptions}
              defaultSelected={[]}
              selectedInputsValues={selectedInputsValuesStatus}
              setSelectedInputsValues={setSelectedInputsValuesStatus}
            />
          </div>
          {multiOptionsCode && selectedInputsCode && (
            <div>
              <SelectInputs
                label={'Filtruj wg przypisanego kodu'}
                startWhenEmptyValue={'Wybierz kod'}
                multiOptions={multiOptionsCode}
                defaultSelected={[]}
                selectedInputsValues={selectedInputsCode}
                setSelectedInputsValues={
                  setSelectedInputsCode as React.Dispatch<
                    React.SetStateAction<string[]>
                  >
                }
              />
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}

export default React.memo(FilterSection)
